import React from "react";
import styled from "styled-components";

import { down } from "~/src/config/vars";
import Character from "~/src/components/blocks/banner/Character";

import animationData from "~/src/components/blocks/banner/CharacterQuiz.json";

const CharacterQuiz = () => {
    return (
        <SCharacterQuiz>
            <Character data={animationData} block_id="BlockTest" />
        </SCharacterQuiz>
    );
};

const SCharacterQuiz = styled.div`
    position: absolute;
    bottom: 14vw;
    right: 11vw;
    width: 12vw;
    z-index: 3;
    ${down("sm")} {
        bottom: 9vw;
        right: 9vw;
        width: 22vw;
    }
    svg {
        width: 100%;
    }
`;

export default CharacterQuiz;
